<section class="w-full bg-transparent h-full">
  <div class="h-full">
    <!-- Tile Wrapper -->
    <div class="relative w-full h-full text-[#F3EEE8] flex flex-col">

      <!-- Title Frame -->
      <div class="px-3 pt-4 border-2 border-black">
        <div class="bg-[#3A3A3A] py-2">
          <h2
            class="text-center whitespace-nowrap text-[#E1CEB9] text-2xl font-primary font-bold tracking-wide"
          >
            {{ data?.title }}
          </h2>
        </div>
      </div>

      <!-- Spacer unter Title -->
      <div class="px-[14px]">
        <div class="bg-[#3A3A3A] pt-4"></div>
      </div>

      <!-- Main Card -->
      <div class="border-2 border-black px-3 pb-4 flex-1">
        <div class="bg-[#3A3A3A] px-4 py-8 flex flex-col h-full">

          <!-- Benefits -->
          <div class="flex flex-col gap-6">
            <div
              class="flex items-start gap-5"
              *ngFor="let benefit of data?.benefits"
            >
              <!-- Fixed Icon -->
              <div
                class="shrink-0 border border-[#F3EEE8] w-12 h-12 flex items-center justify-center"
              >
                <img
                  [src]="benefitIconSrc"
                  class="w-12 h-12 before:border-none"
                  alt=""
                />
              </div>

              <!-- Benefit Text -->
              <div class="text-base text-white leading-snug">
                {{ benefit }}
              </div>
            </div>
          </div>

          <!-- Bottom Area -->
          <div class="mt-auto">
            <!-- Invest -->
            <div class="mt-12 text-center">
              <div class="text-2xl sm:text-3xl font-primary font-semibold">
                {{ data?.investLabel }} {{ data?.investMainPrice }}
              </div>

              <div class="mt-2 text-base font-primary">
                {{ data.investSubline }}
              </div>
            </div>

            <!-- CTA -->
            <div class="mt-10">
              <jnguyen-button
                class="w-full block"
                [button]="data?.button.fields"
              ></jnguyen-button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>